const allowCategories = [
  "Entrantes y Aditivos",
  "Desayunos",
  "Pizzas y Espaguetis",
  "Hamburguesas y Sandwish",
  "Tacos",
  "Bebidas",
  "Cocteles",
  "Postres",
  "Infusiones-Cafe-Te",
];

export const validateProduct = ({ product, required = 1 }) => {
  let ok = 1;
  let { name, category, description, price } = product;
  if (category) category = category.value;

  const Errors = {
    name: "",
    category: "",
    price: "",
    description: "",
  };
  if (name.length === 0 && required) {
    Errors.name = "El nombre del producto es requerido.";
    ok = 0;
  }

  if (!category.length && required) {
    Errors.category = "La categoria del producto es requerida.";
    ok = 0;
  } else if (!allowCategories.includes(category)) {
    Errors.category = "La categoria es invalida.";
    ok = 0;
  }
  if (!description.length && required) {
    Errors.description = "La descripcion del producto es requerida.";
    ok = 0;
  }
  if (!price && required) {
    Errors.price = "El precio del producto es requerido.";
    ok = 0;
  } else if (
    Number.parseInt(price) < 0 ||
    !(Math.floor(price) === Math.ceil(price))
  ) {
    Errors.price = "El precio debe ser un numero entero positivo.";
    ok = 0;
  }

  return {
    success: ok,
    errors: Errors,
  };
};

/// devuelve un object : {success : (true or false) , errors}
